import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import { sidebarWidth } from "./ProjectSidebar";
import useFetch from "hooks/useFetch";
import { useParams } from "react-router-dom";
import MutateGroupMenu from "components/project/MutateGroupMenu";
import NewProjectButton from "components/project/NewProjectButton";

export default function Header() {
  const { customerId } = useParams();
  const { data: customerRes } = useFetch(`/customer`);
  const showAllProjects = !customerId;

  const customer = customerRes?.customers.find(
    (c) => Number(c.id) === Number(customerId)
  );
  const title = customer?.name || "All Projects";

  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${sidebarWidth}px)`,
        ml: `${sidebarWidth}px`,
        backgroundColor: "background.default",
        boxShadow: "none",
      }}
    >
      <Toolbar sx={{ p: 2, display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h4" color="text.primary">
          {title}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <NewProjectButton />
          {!showAllProjects && <MutateGroupMenu />}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
